import styled from 'styled-components';
import { primitives } from '@veneer/primitives';
import { Card } from '@veneer/core';

const { color, typography, layout } = primitives;

export const NextStepsContainer = styled(Card)`
  max-width: 526px;
`;

export const HPAppSection = styled.div``;

export const NextStepsCard = styled.div`
  background: ${color.white};
  border-radius: ${layout.cornerRadius2};
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  width: 100%;
  min-height: 120px;

  @media (max-width: 768px) {
    border-radius: ${layout.cornerRadius2};
  }
`;

export const NextStepsContentLeft = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 0 16px 16px;
`;

export const NextStepsContentRight = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 243px;
`;

export const NextStepsTitle = styled.h3`
  font-family: ${typography.family0};
  color: ${color.black};
  font-size: ${typography.size4};
  font-weight: ${typography.weight4};
  line-height: ${typography.lineHeight4};
  margin: 0;
`;

export const NextStepsDescription = styled.p`
  font-family: ${typography.family0};
  color: ${color.black};
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight2};
  font-weight: ${typography.weight3};
  margin: 0;
`;

export const AppButton = styled.div`
  align-self: flex-start;

  @media (max-width: 768px) {
    align-self: center;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    align-items: flex-end;
    justify-content: center;
  }
`;

export const ItemImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;

  @media (max-width: 768px) {
    width: auto;
    object-fit: cover;
    margin-bottom: 85px;
    display: flex;
    align-items: flex-start;
    border-radius: 0 8px 0 0;
  }
`;
